<template>
    <kgr-input
        type="number"
        :value="value !== null ? value.toString() : ''"
        :label="label"
        :inline="inline"
        :error="error || internalError"
        :is-invalid="isInvalid"
        :disabled="disabled"
        :no-arrows="noArrows"
        @post-input="handleInput"
    />
</template>

<script>
import Input from './Input';

export default {
    components: {
        'kgr-input': Input,
    },
    props: {
        value: {
            required: true,
            validator: (prop) => typeof prop === 'number' || prop === null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false,
        },
        integerOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowNull: {
            type: Boolean,
            required: false,
            default: false,
        },
        noArrows: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            internalError: null,
        };
    },
    methods: {
        handleInput(inputAsString) {
            this.internalError = null;
            if (inputAsString.trim() === '') {
                this.$emit('input', null);
                this.$nextTick(() => {
                    this.$emit('post-input', null);
                });
                if (!this.allowNull) {
                    this.internalError = this.$t('Dieses Feld sollte nicht leer sein.');
                }
                return;
            }

            const asInt = Number.parseInt(inputAsString);
            const asFloat = Number.parseFloat(inputAsString);

            if (asInt.toString() === inputAsString) {
                this.$emit('input', asInt);
                this.$nextTick(() => {
                    this.$emit('post-input', asInt);
                });
                return;
            }

            if (this.integerOnly || isNaN(asFloat)) {
                this.internalError = this.$t('integer.invalidValue');
            }

            const floatNumber = isNaN(asFloat) ? null : asFloat;
            this.$emit('input', floatNumber);
            this.$nextTick(() => {
                this.$emit('post-input', floatNumber);
            });
        },
    },
};
</script>
